<script setup>
import {
    watch,
} from 'vue';
import {
    commitAndShowModal,
} from '../../../utils/error';

const props = defineProps({
    error: {
        default: null,
        type: Error,
    },
});

watch(() => props.error, () => {
    if (!props.error) return;
    commitAndShowModal(props.error);
}, { immediate: true });
</script>
<template><div><slot/></div></template>
